import type { FC, ReactElement } from 'react';

import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import { Button, ButtonVariant } from '../controls/button/Button';
import { IconButton, Icons } from '../controls/iconButton/IconButton';

import type { ToastProps } from './types';

import styles from './Toast.module.css';

export const Toast: FC<ToastProps> = ({
  button,
  duration = 6000,
  icon,
  message,
  msgDynamicValues,
  onClose,
}): ReactElement => {
  return (
    <div data-testid="toast" className={styles.toast}>
      <div className={styles.toast_container}>
        {icon ?? <div />}

        <div data-testid="toast-text" className={styles.toast_text}>
          <L10nText tk={message} dynamicValues={msgDynamicValues} />
        </div>

        {button ? <Button className={styles.toast_btn} variant={ButtonVariant.MAIN} {...button} /> : <div />}

        <IconButton data-testid="toast-timer" icon={Icons.Close} onClick={onClose} timer={duration} />
      </div>
    </div>
  );
};
